export function getUserInitials(
  firstName?: string,
  familyName?: string,
  fallback = 'U',
) {
  const parts = [firstName, familyName]
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part));

  return parts
    .map((part) => part[0])
    .join('')
    .toUpperCase() || fallback;
}
